import React from "react";
import { Select } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import FieldFrame from "./FieldFrame";

const SelectField = ({ field, control, disabled, error, required }) => (
  <Controller
    control={control}
    name={field.code}
    render={({ field: input }) => (
      <FieldFrame field={field} error={error} isRequired={required}>
        <Select {...input} value={input.value ?? ""} placeholder="Select" isDisabled={disabled}>
          {(field.options || [])
            .filter((option) => option.active !== false)
            .map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
        </Select>
      </FieldFrame>
    )}
  />
);

export default SelectField;
